/**
 * @flow
 * @relayHash 288de3b985a3689545ab538726f0266b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type confirmRsvpInput = {|
  clientMutationId?: ?string,
  eventId: string,
  id: string,
|};
export type confirmRsvpMutationVariables = {|
  input: confirmRsvpInput
|};
export type confirmRsvpMutationResponse = {|
  +confirmRsvp: ?{|
    +attendee: ?{|
      +id: string
    |}
  |}
|};
export type confirmRsvpMutation = {|
  variables: confirmRsvpMutationVariables,
  response: confirmRsvpMutationResponse,
|};
*/


/*
mutation confirmRsvpMutation(
  $input: confirmRsvpInput!
) {
  confirmRsvp(input: $input) {
    attendee {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "confirmRsvpInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "confirmRsvp",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "confirmRsvpPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "attendee",
        "storageKey": null,
        "args": null,
        "concreteType": "Attendee",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "confirmRsvpMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "confirmRsvpMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "confirmRsvpMutation",
    "id": null,
    "text": "mutation confirmRsvpMutation(\n  $input: confirmRsvpInput!\n) {\n  confirmRsvp(input: $input) {\n    attendee {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fde335850015b8d0326e46894b0a9e03';
module.exports = node;
